import { render, staticRenderFns } from "./CampaignDetailsDialog.vue?vue&type=template&id=e15ae2d2&scoped=true&"
import script from "./CampaignDetailsDialog.vue?vue&type=script&lang=js&"
export * from "./CampaignDetailsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e15ae2d2",
  null
  
)

export default component.exports